import * as Yup from 'yup';

export function searchValidator() {
  return Yup.object().shape({
    search: Yup.string(),
  });
}
